import { Component, OnInit } from '@angular/core';
import { DataService } from '../../../services/data.service';
import { MessageService } from '../../../services/message.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-index-surcharges',
  templateUrl: './index-surcharges.component.html',
  styleUrls: ['./index-surcharges.component.css'],
})
export class IndexSurchargesComponent implements OnInit {
  url: string = 'openai';
  data: any[] = [];
  loading: boolean = true;
  searchText = '';
  searchSuggestions: string[] = [];
  filteredData: Array<any> = [];
  step = 0;

  resumenCards = [
    {
      label: '',
      value: 0,
      icon: 'fas fa-users',
      bgClass: 'bg-white',
      desc: 'Distance',
      route: '/logistics/fees',
    },
    {
      label: '',
      value: 0,
      icon: 'fas fa-user-clock',
      bgClass: 'bg-white',
      desc: 'Volume',
      route: '/logistics/fees/volume',
    },
    {
      label: '',
      value: 0,
      icon: 'fas fa-user-clock',
      bgClass: 'bg-white',
      desc: 'Weight',
      route: '/logistics/fees/weight',
    },
    {
      label: '',
      value: 0,
      icon: 'fas fa-city',
      bgClass: 'bg-white',
      //desc: 'T2D Charges',
      desc: 'Runner',
      route: '/logistics/fees/task',
    },
    {
      label: '',
      value: 0,
      icon: 'fas fa-user-check',
      bgClass: 'bg-white',
      desc: 'Surcharges',
      route: '/logistics/fees/surcharges',
    },
    /* {
      label: '',
      value: 0,
      icon: 'fas fa-user-check',
      bgClass: 'bg-white',
      desc: 'EMM',
      route: '/logistics/fees/emm',
    }, */
  ];

  resumenCardsTwo = [
    {
      //label: 'TN',
      value: '',
      icon: 'fas fa-user',
      bgClass: 'bg-white',
      desc: 'Drivers',
      route: '/logistics',
    },
    {
      //label: 'TN',
      value: '',
      icon: 'fas fa-user',
      bgClass: 'bg-white',
      desc: 'Customers',
      route: '/logistics/customers',
    },
    {
      //label: 'TN',
      value: '',
      icon: 'fas fa-money-bill',
      bgClass: 'bg-white',
      desc: 'Metrics',
      route: '/logistics/fees',
    },
  ];

  constructor(
    private dataService: DataService,
    private messageService: MessageService,
    private router: Router,
  ) {}

  ngOnInit(): void {
    console.log('Componente inicializado');
    this.getData();
  }

  getData(): void {
    this.loading = true;
    this.data = [];
    console.log('Obteniendo recargos...');
    this.step = 0;

    this.dataService
      .getData(`${this.url}/getAllSurchargesExceptLuxuryHotels`)
      .subscribe({
        next: (response: any) => {
          console.log('Datos recibidos:', response);
          if (response && response.data && Array.isArray(response.data)) {
            this.data = response.data;
            console.log('Datos asignados:', this.data);
            this.filteredData = [...this.data];
            this.updateSuggestions();
          } else {
            console.error(
              'La respuesta no tiene el formato esperado:',
              response,
            );
            this.messageService.add('Error al cargar los datos', 'danger');
          }
          this.loading = false;
        },
        error: (error) => {
          console.error('Error al obtener datos:', error);
          this.messageService.add('Error al cargar los datos', 'danger');
          this.loading = false;
        },
      });
  }

  deleteData(id: string): void {
    if (!confirm('¿Desea eliminar el registro?')) {
      return;
    }

    this.dataService
      .deleteData(`${this.url}/surcharges_delete/${id}`)
      .subscribe({
        next: (response: any) => {
          if (response.rst) {
            this.messageService.add(response.msg, 'info');
            this.getData();
          } else {
            this.getData();
            this.messageService.add(
              'Registro eliminado correctamente',
              'danger',
            );
          }
        },
        error: (error) => {
          console.error('Error al eliminar:', error);
          this.messageService.add('Error al eliminar el registro', 'danger');
        },
      });
  }

  filterCourier() {
    const texto = this.searchText.trim().toLowerCase();
    if (!texto) {
      this.filteredData = [...this.data];
    } else {
      this.filteredData = this.data.filter((item) => {
        return item.name && item.name.toLowerCase().includes(texto);
      });
    }
  }

  updateSuggestions() {
    const sugerenciasSet = new Set<string>();
    this.data.forEach((item) => {
      if (item.name) sugerenciasSet.add(item.name);
    });
    this.searchSuggestions = Array.from(sugerenciasSet).filter(Boolean);
  }

  onHotelsClick() {
    this.step = 1;
    console.log('Se hizo clic en Hoteles');
    this.dataService
      .getData(`${this.url}/getAllLuxuryHotelSurcharges`)
      .subscribe({
        next: (response: any) => {
          console.log('Datos recibidos:', response);
          if (response && response.data && Array.isArray(response.data)) {
            this.data = response.data;
            console.log('Datos asignados:', this.data);
            this.filteredData = [...this.data];
            this.updateSuggestions();
          } else {
            console.error(
              'La respuesta no tiene el formato esperado:',
              response,
            );
            this.messageService.add('Error al cargar los datos', 'danger');
          }
          this.loading = false;
        },
        error: (error) => {
          console.error('Error al obtener datos:', error);
          this.messageService.add('Error al cargar los datos', 'danger');
          this.loading = false;
        },
      });
  }
}
